export default "__VITE_ASSET__1624386b__"